import React, { useEffect, useState } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import ScannerIcon from "@material-ui/icons/Scanner";

import {
    useStylesUp, useStylesHed, useStylesAuto, useStylesAutoPurch, useStylesTF, useStylesTD, useStylesBA, useStylesLbl
    , useStylesUiElemment,
    useStylesSpDial,
} from '../../../St/Reports/UseStyle';
import { Button, colors, Container, Paper } from '@material-ui/core';
import { useTranslation } from "react-i18next";
import KeyboardReturnSharpIcon from "@material-ui/icons/KeyboardReturnSharp";

export default function PricesLevelsForms(props) {
    const { t } = useTranslation(["forms", "translation"]);

    const {
        AutoOptions,
        rptParams,
        onChangeData,
        onChangeAutoData,
        rptParamsAuto,
        onChangeSearch,
        changTField,
        optionsUnits
    } = props;

    const clasup = useStylesUp();
    const calsPurch = useStylesAutoPurch();
    const claslbl = useStylesLbl();
    const clasAo = useStylesAuto();
    const clasTF = useStylesTF();

    return (
        <React.Fragment>

            <Grid container style={{ padding: 5 }} spacing={1}>
                <Grid item lg={4} md={3} sm={3} xs={3}>
                    <TextField
                        fullWidth
                        variant="outlined"
                        size="small"
                        id="id"
                        label={t("no")}
                        InputLabelProps={{ className: claslbl.clrBlackLblS }}
                        InputProps={{ className: claslbl.clrBlackTxt, readOnly: true }}
                        type="text"
                        name="id"
                        value={rptParams.id}
                        onChange={changTField("id")}
                    />
                </Grid>
                <Grid item lg={8} md={6} sm={6} xs={6} style={{ marginBottom: "0.5rem" }} >
                    <TextField
                        type="text"
                        fullWidth
                        variant="outlined"
                        size="small"
                        id="barcode"
                        label={t("forms:barcode")}
                        style={{ backgroundColor: colors.red[50], marginBlock: 5 }}
                        name="barcode"
                        value={rptParams.barcode}
                        InputProps={{
                            onKeyDown: (event) => {
                                if (event.key === 'Enter') {
                                    onChangeSearch(event);
                                }
                            },
                        }}
                        onChange={onChangeData("barcode")} />
                </Grid>
                <Grid item lg={6} md={6} sm={6} xs={6} style={{ marginBottom: "0.5rem" }}>
                    <Autocomplete classes={clasAo}
                        value={rptParamsAuto?.item}
                        onChange={(event, newValue) => {
                            onChangeAutoData("item", newValue);
                        }}
                        id="combo-box-demo"
                        size="small"
                        options={AutoOptions?.InvItems}
                        getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.name
                        }
                        style={{}}
                        disableClearable
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                InputLabelProps={{ shrink: true, className: claslbl.clrSale }}
                                label={t("item")}
                                variant="outlined"
                            />
                        )}
                    />
                </Grid>
                <Grid item lg={6} md={6} sm={6} xs={6} style={{ marginBottom: "0.5rem" }}>
                    <Autocomplete classes={clasAo}
                        value={rptParamsAuto?.unit}
                        onChange={(event, newValue) => {
                            onChangeAutoData("unit", newValue);

                        }}
                        id="combo-box-demo"
                        size="small"
                        options={optionsUnits}
                        getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.unitName
                        }
                        style={{}}
                        disableClearable
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                InputLabelProps={{ shrink: true, className: claslbl.clrSale }}
                                label={t("unit")}
                                variant="outlined"
                            />
                        )}
                    />
                </Grid>

                <Grid item lg={6} md={6} sm={6} xs={6} style={{ marginBottom: "0.5rem" }} >
                    <TextField
                        type="number"
                        fullWidth
                        variant="outlined"
                        size="small"
                        id="price"
                        label={t("price")}
                        style={{ backgroundColor: colors.red[50], marginBlock: 5 }}
                        name="barcode"
                        value={rptParams.price}
                       
                        onChange={onChangeData("price")} />
                </Grid>
                <Grid item lg={6} md={6} sm={6} xs={6} style={{ marginBottom: "0.5rem" }} >
                    <TextField
                        type="number"
                        fullWidth
                        variant="outlined"
                        size="small"
                        id="minPrice"
                        label={t("min-limit")}
                        style={{ backgroundColor: colors.red[50], marginBlock: 5 }}
                        name="minPrice"
                        value={rptParams.minPrice}
                        // InputProps={{
                        //     onKeyDown: (event) => {
                        //         if (event.key === 'Enter') {
                        //             onChangeSearch(event);
                        //         }
                        //     },
                        // }}
                        onChange={onChangeData("minPrice")} />
                </Grid>
                <Grid item lg={6} md={6} sm={6} xs={6} style={{ marginBottom: "0.5rem" }} >
                    <TextField
                        type="number"
                        fullWidth
                        variant="outlined"
                        size="small"
                        id="maxPrice"
                        label={t("max-limit")}
                        style={{ backgroundColor: colors.red[50], marginBlock: 5 }}
                        name="maxPrice"
                        value={rptParams.maxPrice}
                        // InputProps={{
                        //     onKeyDown: (event) => {
                        //         if (event.key === 'Enter') {
                        //             onChangeSearch(event);
                        //         }
                        //     },
                        // }}
                        onChange={onChangeData("maxPrice")} />
                </Grid>
                <Grid item lg={6} md={6} sm={6} xs={6} style={{ marginBottom: "0.5rem" }}>
                    <Autocomplete classes={clasAo}
                        value={rptParamsAuto?.level}
                        onChange={(event, newValue) => {
                            onChangeAutoData("level", newValue);

                        }}
                        id="combo-box-demo"
                        size="small"
                        options={AutoOptions.Levels}
                        getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.name
                        }
                        style={{}}
                        disableClearable
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                InputLabelProps={{ shrink: true, className: claslbl.clrSale }}
                                label={t("level")}
                                variant="outlined"
                            />
                        )}
                    />
                </Grid>

                <Grid item lg={6} md={6} sm={6} xs={6} style={{ marginBottom: "0.5rem" }}>
                    <Autocomplete classes={clasAo}
                        value={rptParamsAuto?.branch}
                        onChange={(event, newValue) => {
                            onChangeAutoData("branch", newValue);

                        }}
                        id="combo-box-demo"
                        size="small"
                        options={AutoOptions.Branches}
                        getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.name
                        }
                        style={{}}
                        disableClearable
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                InputLabelProps={{ shrink: true, className: claslbl.clrSale }}
                                label={t("branch")}
                                variant="outlined"
                            />
                        )}
                    />
                </Grid>

                
            </Grid>

        </React.Fragment >
    );

}